import { Dispatch } from 'store/store';
import { useMutation } from '@tanstack/react-query';
import { RQAPICall } from 'store/APIClient';

/**
 * Constructs the endpoint for duplicating budget proposal settings.
 */
const getSettingsDuplicationEndpoint = (
    budgetProposalId: number,
    resourceSoftwareId: string,
): string =>
    `/budget/proposals/${budgetProposalId}/settings/duplicate/${resourceSoftwareId}`;

/**
 * Custom hook to duplicate budget proposal settings.
 */
export const useDuplicateSettings = (dispatch: Dispatch) => {
    return useMutation({
        mutationFn: async ({
            sourceBudgetProposalId,
            sourceResourceSoftwareId,
            targetBudgetProposalIds,
            targetResourceSoftwareIds,
        }: {
            sourceBudgetProposalId: number;
            sourceResourceSoftwareId: string;
            targetBudgetProposalIds: number[];
            targetResourceSoftwareIds: string[];
        }) => {
            return RQAPICall({
                endpoint: getSettingsDuplicationEndpoint(
                    sourceBudgetProposalId,
                    sourceResourceSoftwareId,
                ),
                method: 'PATCH',
                body: {
                    budget_proposals_ids: targetBudgetProposalIds,
                    resources_software_ids: targetResourceSoftwareIds,
                },
            });
        },

        onSuccess: (response) => {
            dispatch.vision.notifyUser({
                message: response.content.message,
                snackType: 'success',
            });
        },

        meta: {
            useGlobalOnError: true,
        },
    });
};
